import { render, staticRenderFns } from "./CostQuotesRates.vue?vue&type=template&id=5a5b9666&scoped=true"
import script from "./CostQuotesRates.vue?vue&type=script&lang=js"
export * from "./CostQuotesRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5b9666",
  null
  
)

export default component.exports